import { render, staticRenderFns } from "./CollectionActions.vue?vue&type=template&id=7f74ecb9&scoped=true&"
import script from "./CollectionActions.vue?vue&type=script&lang=ts&"
export * from "./CollectionActions.vue?vue&type=script&lang=ts&"
import style0 from "./CollectionActions.vue?vue&type=style&index=0&id=7f74ecb9&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f74ecb9",
  null
  
)

export default component.exports